/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const UPLOADPDFILEPOST= createAsyncThunk(
  "uploadFilesPost/uploadFilesPost",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const uploadFilesPostSlice = createSlice({
  name: "uploadFilesPostSlice",
  initialState: {
    uploadFilesPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfuploadFilesPost: (state) => {
        state.uploadFilesPost.loading = false
        state.uploadFilesPost.error = false
        state.uploadFilesPost.data = []
        state.uploadFilesPost.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPLOADPDFILEPOST.fulfilled, (state, action) => {
      state.uploadFilesPost = {
        ...state.uploadFilesPost,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPLOADPDFILEPOST.pending, (state, action) => {
      state.uploadFilesPost = {
        ...state.uploadFilesPost,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPLOADPDFILEPOST.rejected, (state, action) => {
      state.uploadFilesPost = {
        ...state.uploadFilesPost,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const uploadFilesPostAction = {
    UPLOADPDFILEPOST,
};

export { uploadFilesPostAction };
export default uploadFilesPostSlice.reducer;
export const {setInitialStateOfuploadFilesPost} = uploadFilesPostSlice.actions